/* src/app/components/containers/bulk-import/bulk-import.component.css */
:host {
  display: block;
  --blue:#2f6df6;
  --blue-d:#1d54d6;
  --blue-soft:#eaf1fe;
  --ink:#3d464d;
  --ink2:#313541;
  --muted:#9aa3af;
  --line:#e6e9ef;
  --line2:#f0f2f6;
  --green:#2ca25f;
  --red:#e5484d;
  --red-soft:#fdeced;
  --amber:#d98a04;
  --amber-soft:#fcf3e2;
  font-size: 13px;
  color: var(--ink);
}
.bi-wrap {
  padding: 18px 22px;
}
h2 {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink2);
  margin: 0 0 6px;
}
.bi-sub {
  font-size: 12.5px;
  color: var(--muted);
  margin: 0 0 14px;
}
.bi-steps {
  display: flex;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
}
.bi-steps li {
  flex: 1;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 12px;
  color: var(--muted);
  font-weight: 600;
}
.bi-steps li b {
  display: inline-block;
  width: 17px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  border-radius: 50%;
  background: #eef1f6;
  color: #7a828f;
  font-size: 10px;
  margin-right: 7px;
}
.bi-steps li.on {
  border-color: var(--blue);
  color: var(--blue-d);
  box-shadow: 0 0 0 2px #2f6df622;
}
.bi-steps li.on b {
  background: var(--blue);
  color: #fff;
}
.bi-steps li.done {
  color: var(--green);
  border-color: #bfe0c9;
}
.bi-steps li.done b {
  background: #e8f6ee;
  color: var(--green);
}
.bi-scaffold {
  background: var(--amber-soft);
  border: 1px solid #eccd86;
  color: #8a6100;
  border-radius: 7px;
  padding: 7px 12px;
  font-size: 11.5px;
  font-weight: 600;
  margin-bottom: 14px;
}
.bi-panel {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 14px;
  box-shadow: 0 1px 3px rgba(40, 50, 70, .06);
}
.bi-msg {
  padding: 9px 12px;
  border-radius: 6px;
  margin: 10px 0;
  font-size: 12.5px;
  background: var(--blue-soft);
  color: var(--blue-d);
}
.bi-msg.bad {
  background: var(--red-soft);
  color: #b4292d;
  border: 1px solid #f0b6b6;
}
.bi-msg.good {
  background: #e8f6ee;
  color: var(--green);
  border: 1px solid #b6e0c4;
}
.bi-file {
  display: flex;
  align-items: center;
  gap: 9px;
  font-weight: 600;
  font-size: 13px;
  color: var(--ink2);
  margin: 12px 0;
}
.bi-file .xi {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #e8f6ee;
  color: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.bi-cols {
  margin-top: 14px;
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  align-items: center;
}
.bi-lbl {
  font-size: 11px;
  color: var(--muted);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  margin-right: 4px;
}
.bi-chip {
  font-size: 11.5px;
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 4px 9px;
  background: #fbfcfe;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.bi-chip.un {
  border-style: dashed;
  color: var(--muted);
  background: #fff;
}
.ty {
  font-size: 9px;
  background: #eef1f6;
  color: #7a828f;
  padding: 1px 5px;
  border-radius: 4px;
  font-weight: 700;
  margin-left: 5px;
}
.ty.doc {
  background: #f3e8fd;
  color: #7a3fb0;
}
.bi-note {
  margin-top: 12px;
  font-size: 11.5px;
  color: var(--muted);
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}
.bi-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 20px;
  background: #eef1f6;
  color: #7a828f;
}
.p-green {
  background: #e8f6ee;
  color: var(--green);
}
.p-red {
  background: var(--red-soft);
  color: var(--red);
}
.p-amber {
  background: var(--amber-soft);
  color: var(--amber);
}
.bi-actions {
  margin-top: 18px;
  display: flex;
  gap: 10px;
}
.bi-btn {
  padding: 8px 15px;
  border-radius: 7px;
  font-size: 12.5px;
  font-weight: 600;
  border: 1px solid var(--line);
  background: #fff;
  color: #46505f;
  cursor: pointer;
}
.bi-btn.primary {
  background: var(--blue);
  border-color: var(--blue);
  color: #fff;
  box-shadow: 0 1px 2px rgba(47, 109, 246, .35);
}
.bi-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.bi-btn.ghost {
  background: var(--blue-soft);
  border-color: #c6d9fd;
  color: var(--blue-d);
}
.bi-btn.ghost .xi {
  margin-right: 6px;
  font-size: 13px;
}
.bi-template {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin: 0 0 16px;
  padding: 12px 14px;
  border: 1px dashed #c6d9fd;
  border-radius: 8px;
  background: #f7faff;
}
.bi-template .bi-btn {
  flex: 0 0 auto;
  white-space: nowrap;
}
.bi-template-help {
  font-size: 11.5px;
  line-height: 1.5;
  color: #5d6773;
}
table.bi-map {
  border-collapse: collapse;
  width: 100%;
  max-width: 820px;
}
table.bi-map th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  padding: 8px 10px;
  border-bottom: 1px solid var(--line);
}
table.bi-map td {
  padding: 6px 10px;
  border-bottom: 1px solid var(--line2);
  vertical-align: top;
}
table.bi-map td.arrow {
  color: var(--muted);
}
table.bi-map tr.dupe td {
  background: var(--amber-soft);
}
.bi-ctxbar {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  box-shadow: 0 1px 2px rgba(40, 50, 70, .04);
}
.bi-ctxbar .bi-file {
  margin: 0;
}
.seg {
  display: flex;
  border: 1px solid var(--line);
  border-radius: 7px;
  overflow: hidden;
}
.seg button {
  border: 0;
  background: #fff;
  padding: 6px 13px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
}
.seg button.on {
  background: var(--blue-soft);
  color: var(--blue-d);
}
.pills {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
.bi-tablewrap {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(40, 50, 70, .07);
}
.bi-tablehead {
  padding: 13px 16px 11px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink2);
  border-bottom: 1px solid var(--line2);
}
.bi-tablehead .res {
  color: var(--muted);
  font-weight: 500;
}
.bi-scroll {
  overflow: auto;
  max-height: 58vh;
}
.bi-scroll.short {
  max-height: 40vh;
  border: 1px solid var(--line);
  border-radius: 6px;
  margin-top: 10px;
}
table.bi-tbl {
  width: 100%;
  border-collapse: collapse;
}
table.bi-tbl thead th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  padding: 11px 12px;
  border-bottom: 1px solid var(--line);
  background: #fafbfd;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
table.bi-tbl thead th.req::after {
  content: "*";
  color: var(--red);
  margin-left: 2px;
}
table.bi-tbl tbody td {
  padding: 6px 10px;
  border-bottom: 1px solid var(--line2);
  vertical-align: top;
}
table.bi-tbl tbody tr:hover {
  background: #fafbff;
}
tr.rowerr {
  background: #fffafa;
}
tr.rowerr:hover {
  background: #fff5f5;
}
.num {
  width: 42px;
  text-align: center;
}
.rownum {
  color: var(--muted);
  font-size: 11px;
  text-align: center;
  width: 42px;
  vertical-align: middle;
}
table.bi-tbl thead th:nth-child(1),
table.bi-tbl thead th:nth-child(2),
table.bi-tbl thead th:nth-child(3) {
  position: sticky;
  z-index: 3;
  background: #fafbfd;
}
table.bi-tbl tbody td:nth-child(1),
table.bi-tbl tbody td:nth-child(2),
table.bi-tbl tbody td:nth-child(3) {
  position: sticky;
  z-index: 2;
  background: #fff;
}
table.bi-tbl thead th:nth-child(1),
table.bi-tbl tbody td:nth-child(1) {
  left: 0;
  width: 38px;
}
table.bi-tbl thead th:nth-child(2),
table.bi-tbl tbody td:nth-child(2) {
  left: 38px;
}
table.bi-tbl thead th:nth-child(3),
table.bi-tbl tbody td:nth-child(3) {
  left: 80px;
  box-shadow: 1px 0 0 var(--line2);
}
table.bi-tbl tbody tr:hover td:nth-child(1),
table.bi-tbl tbody tr:hover td:nth-child(2),
table.bi-tbl tbody tr:hover td:nth-child(3) {
  background: #fafbff;
}
tr.rowerr td:nth-child(1),
tr.rowerr td:nth-child(2),
tr.rowerr td:nth-child(3) {
  background: #fffafa;
}
tr.rowerr:hover td:nth-child(1),
tr.rowerr:hover td:nth-child(2),
tr.rowerr:hover td:nth-child(3) {
  background: #fff5f5;
}
tr.rowoff > td {
  opacity: .42;
}
tr.rowoff > td:nth-child(1) {
  opacity: 1;
}
td.sel,
th.sel {
  width: 38px;
  text-align: center;
  vertical-align: middle;
}
td.sel input,
th.sel input {
  cursor: pointer;
  width: 15px;
  height: 15px;
}
td.sel input:disabled {
  cursor: not-allowed;
  opacity: .35;
}
table.bi-tbl tbody td.num {
  vertical-align: middle;
}
.errtxt {
  color: #b4292d;
  font-size: 11.5px;
}
.rstat {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.s-ok {
  background: var(--green);
}
.s-err {
  background: var(--red);
}
.s-warn {
  background: var(--amber);
}
.bi-ctl {
  display: flex;
  align-items: center;
  height: 30px;
  border: 1px solid var(--line);
  border-radius: 7px;
  padding: 0 9px;
  background: #fff;
  font-size: 12.5px;
  min-width: 130px;
  max-width: 230px;
  color: var(--ink2);
  font-family: inherit;
}
select.bi-ctl {
  min-width: 150px;
}
.bi-ctl.numin {
  min-width: 90px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.bi-ctl.date {
  min-width: 110px;
}
.bi-ctl.inv {
  font-weight: 600;
  color: var(--blue-d);
  font-variant-numeric: tabular-nums;
  letter-spacing: .2px;
}
.bi-ctl.inv.err {
  color: #b4292d;
}
select.bi-ctl.dd {
  background: #f7faff;
  color: var(--blue-d);
  font-weight: 600;
}
select.bi-ctl.dd.err {
  background: var(--red-soft);
  color: #b4292d;
}
select.bi-ctl.dd.warn {
  background: var(--amber-soft);
  color: #8a6100;
}
.bi-ctl.chk {
  gap: 7px;
  min-width: 70px;
  cursor: pointer;
}
.bi-ctl.err {
  border-color: var(--red);
  background: var(--red-soft);
  color: #b4292d;
}
.bi-ctl.warn {
  border-color: #eccd86;
  background: var(--amber-soft);
}
.bi-emsg {
  font-size: 10.5px;
  margin-top: 3px;
  color: var(--red);
  max-width: 230px;
  line-height: 1.35;
}
.bi-emsg.w {
  color: var(--amber);
}
.bi-resolved {
  font-size: 10px;
  margin-top: 3px;
  color: #8d96a3;
}
input#bi-file {
  display: block;
  width: 100%;
  max-width: 520px;
  font-size: 12.5px;
  color: var(--ink2);
  border: 1px dashed var(--line);
  border-radius: 8px;
  padding: 14px;
  background: #fbfcfe;
  cursor: pointer;
}
input#bi-file::file-selector-button {
  margin-right: 12px;
  padding: 7px 14px;
  border-radius: 7px;
  border: 1px solid var(--line);
  background: #fff;
  color: #46505f;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}
input#bi-file:hover {
  border-color: #c6d9fd;
  background: #f7faff;
}
.bi-gridfoot {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  background: #fafbfd;
  border-radius: 0 0 8px 8px;
  gap: 16px;
  flex-wrap: wrap;
}
.bi-gridfoot .summ {
  font-size: 12.5px;
  color: var(--ink2);
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  flex: 1;
}
.summ b {
  font-weight: 700;
}
.summ .ok b {
  color: var(--green);
}
.summ .er b {
  color: var(--red);
}
.summ .warnnote {
  color: var(--amber);
}
.pager {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.bi-tablehead {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}
.bi-tablehead .grow {
  flex: 1;
}
.bi-tablehead .sel {
  color: var(--ink2);
}
.bi-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  cursor: pointer;
  color: var(--ink2);
  -webkit-user-select: none;
  user-select: none;
}
.bi-toggle input {
  cursor: pointer;
}
.bi-pagesize {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 500;
  color: var(--ink2);
}
.bi-pagesize select {
  padding: 3px 6px;
  font-size: 12px;
}
.p-blue {
  background: #e9effb;
  color: #2f5bd0;
}
.bi-gridfoot .pagenav {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pgtxt {
  font-size: 12.5px;
  color: var(--ink2);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.pgtxt .dim,
.dim {
  color: var(--muted);
}
.bi-btn.sm {
  padding: 3px 10px;
  font-size: 13px;
  line-height: 1.4;
}
.bi-cols.unsup {
  margin-top: 10px;
}
.bi-cols.unsup .bi-lbl {
  color: #8a8f98;
}
.bi-chip.off {
  background: #f2f3f5;
  border: 1px dashed #c9ccd2;
  color: #8a8f98;
  cursor: not-allowed;
  opacity: .85;
}
.bi-chip.off b {
  color: #6f747c;
  font-weight: 600;
  text-decoration: line-through;
}
.bi-chip.off .why {
  margin-left: 6px;
  font-size: 11px;
  font-style: italic;
  color: #9aa0a8;
}
.bi-tablehead .bi-colcount {
  color: var(--ink2);
  font-weight: 500;
}
.bi-tablehead .bi-colcount .res {
  color: var(--muted);
}
.bi-note.prose {
  display: block;
  line-height: 1.5;
}
.bi-note.prose b {
  color: var(--ink2);
}
.bi-mfilter {
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 4px 0 14px;
  flex-wrap: wrap;
}
.bi-mfilter input {
  flex: 1 1 260px;
  min-width: 200px;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #cfd6dd;
  border-radius: 4px;
  background: #fff;
}
.bi-mfilter input:focus {
  outline: none;
  border-color: #1a73e8;
}
.bi-seg {
  display: inline-flex;
  border: 1px solid #cfd6dd;
  border-radius: 4px;
  overflow: hidden;
}
.bi-seg button {
  border: 0;
  background: #fff;
  padding: 8px 14px;
  font-size: 12px;
  cursor: pointer;
  color: #4a5560;
  border-left: 1px solid #e3e8ec;
}
.bi-seg button:first-child {
  border-left: 0;
}
.bi-seg button.on {
  background: #1a73e8;
  color: #fff;
}
.bi-mgroup {
  margin-bottom: 18px;
}
.bi-mgroup-h {
  font-size: 11px;
  letter-spacing: .07em;
  text-transform: uppercase;
  color: #7b8794;
  border-bottom: 1px solid #e6ebef;
  padding-bottom: 4px;
  margin-bottom: 8px;
}
.bi-mgrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
  gap: 8px;
}
.bi-mcard {
  display: block;
  text-align: left;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d8dfe5;
  border-radius: 5px;
  padding: 9px 11px;
  font: inherit;
}
.bi-mcard:hover {
  border-color: #1a73e8;
  background: #f5f9ff;
}
.bi-mcard.on {
  border-color: #1a73e8;
  box-shadow: inset 0 0 0 1px #1a73e8;
  background: #f5f9ff;
}
.bi-mcard b {
  display: block;
  font-size: 13px;
  color: #22303c;
  margin-bottom: 3px;
}
.bi-mcard .ty {
  display: inline-block;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .05em;
  background: #e8f0fe;
  color: #1a56b8;
  border-radius: 3px;
  padding: 1px 5px;
  margin-right: 4px;
}
.bi-mcard .ty.reg {
  background: #eef3ee;
  color: #37693f;
}
.bi-mcard .mod {
  font-size: 10px;
  color: #8b95a1;
}
.bi-mcard .fq {
  display: block;
  font-size: 10px;
  color: #9aa4af;
  margin-top: 4px;
}
.bi-link {
  border: 0;
  background: none;
  padding: 0 0 0 8px;
  font: inherit;
  font-size: 12px;
  color: #1a73e8;
  cursor: pointer;
  text-decoration: underline;
}
.bi-pills {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  min-width: 190px;
  max-width: 260px;
  min-height: 30px;
  padding: 3px 5px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #fff;
}
.bi-pills.err {
  border-color: var(--red);
  background: var(--red-soft);
}
.bi-pills.warn {
  border-color: #eccd86;
  background: var(--amber-soft);
}
.bi-tok {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 100%;
  padding: 2px 3px 2px 8px;
  border-radius: 11px;
  font-size: 11.5px;
  line-height: 1.5;
  border: 1px solid transparent;
}
.bi-tok-t {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 170px;
}
.bi-tok-x {
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 0 4px;
  color: inherit;
  opacity: .55;
  font-family: inherit;
}
.bi-tok-x:hover {
  opacity: 1;
}
.bi-tok.t-ok {
  background: #e3f4e8;
  border-color: #b7dfc3;
  color: #1f6b3a;
}
.bi-tok.t-bad {
  background: #fdeaea;
  border-color: #eab3b3;
  color: #b4292d;
  font-weight: 600;
}
.bi-tok.t-unknown {
  background: #eef0f3;
  border-color: #d8dce2;
  color: #5a6472;
}
.bi-tok-add {
  border: 1px dashed #c6d9fd;
  background: #f7faff;
  color: var(--blue-d);
  cursor: pointer;
  border-radius: 11px;
  font-size: 13px;
  line-height: 1;
  padding: 3px 9px;
  font-family: inherit;
  font-weight: 700;
}
.bi-tok-add:hover {
  background: #eaf1ff;
}
.bi-pick {
  margin-top: 5px;
  padding: 7px;
  border: 1px solid #c6d9fd;
  border-radius: 8px;
  background: #f7faff;
  width: 250px;
}
.bi-pick .bi-ctl {
  width: 100%;
  background: #fff;
}
.bi-pick-note {
  font-size: 10.5px;
  color: var(--ink2);
  margin-top: 5px;
  line-height: 1.4;
}
.bi-pick-list {
  margin-top: 5px;
  max-height: 170px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 6px;
}
.bi-pick-o {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: none;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 11.5px;
  font-family: inherit;
  color: var(--ink2);
  line-height: 1.4;
}
.bi-pick-o:hover {
  background: #eaf1ff;
  color: var(--blue-d);
}
.bi-pick-act {
  display: flex;
  gap: 6px;
  margin-top: 7px;
}
/*# sourceMappingURL=bulk-import.component.css.map */
